import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { PublicAppElement } from './public-app-element';

const SCREEN_LARGE: number = 992

export class PublicAppNavigationMenu extends PublicAppElement {
    @property()
    accessor navigationMenuItems: any = undefined;
    navigationSearchResult:any = [];
    _searchText:string = ''

    get searchText() {
        return this._searchText;
    }

    @property({ type: Boolean, reflect: true })
    set searchText(searchText) {
        const oldValue = this._searchText;
        this._searchText = searchText;
        this.requestUpdate("searchText", oldValue);
    }

    constructor() {
        super();
        (async () => {
            this.navigationMenuItems = await this.fetchNavigationMenuItems();
        })();
    }

    async fetchNavigationMenuItems() {
        const response: Response = await fetch("/Public/externalmenu/view?v=" + this.appVersion);
        let navigationMenuData = await response.json();

        return navigationMenuData;
    }

    onSearch = (val) => {
        let result: any = [];
        const searchQuery = val.trimStart()
        const ele: any = this.shadowRoot?.querySelector('#nav-menu-search-input')
        
        if (ele) {
            ele.value = searchQuery
        }

        if (searchQuery.length === 0) {
            this.searchText = ''
            return;
        } else {
            this.searchText = searchQuery

            const searchTextFilter = (obj) => {
                const text = obj?.searchText?.toLowerCase()
                if (text?.includes(searchQuery.toLowerCase())) {
                    return true
                } else return false
            }

            for (let menuItem of this.navigationMenuItems.mainMenu) {
                const menu = JSON.parse(JSON.stringify(menuItem))

                if (menuItem.children && menuItem.children.length > 0) {
                    const submenuRearchResult = menuItem.children.filter(searchTextFilter)
                    menu.children = submenuRearchResult
                    if (menu.children.length > 0) {
                        result.push(menu)
                    }
                } else {
                    if (searchTextFilter(menu)) {
                        result.push(menu)
                    }
                }
            }
        }
        this.navigationSearchResult = result
    }

    groupHeaderClick(e) {
        let head: any = e.target;
        if (head?.closest(".menuGroup")?.querySelector("#menu-option")) {//has at least one child
            this.toggleGroupMenu(e);
        } 
    }
    collapseAllGroupMenu() {
        let allGrpMnuContainers = this.shadowRoot?.querySelector(".nav-menu-container")?.querySelectorAll(".accordion-container")
        if (allGrpMnuContainers && allGrpMnuContainers.length) {
            allGrpMnuContainers.forEach((iterGrpMnuCont, index) => {
                if (iterGrpMnuCont.classList.contains("show")) {
                    this.collapseGrpMnu(iterGrpMnuCont);
                }
            });
        }
    }

    toggleGroupMenu(e) {
        let span = e.target;
        const currentGrpMnuContainer = span?.closest(".menuGroup")?.querySelector(".accordion-container");
        if (!currentGrpMnuContainer) return;
        let allGrpMnuContainers = span?.closest(".nav-menu-container")?.querySelectorAll(".accordion-container")
        if (allGrpMnuContainers && allGrpMnuContainers.length) {
            allGrpMnuContainers.forEach((iterGrpMnuCont, index) => {
                if (iterGrpMnuCont != currentGrpMnuContainer && iterGrpMnuCont.classList.contains("show")) {
                    this.collapseGrpMnu(iterGrpMnuCont);
                }
            });
        }
        if (currentGrpMnuContainer.classList.contains("show")) {//If it is shown, then collapse
            this.collapseGrpMnu(currentGrpMnuContainer);
        } else {
            this.bootStrapExpand(currentGrpMnuContainer); //If not shown, toggle to show it
        }
    }

    collapseGrpMnu(grpMenuContainer) {
        this.bootStrapCollapse(grpMenuContainer);
        let allOpenGrpMenuContainers = grpMenuContainer.querySelectorAll('.collapse.show');
        allOpenGrpMenuContainers.forEach(iterOpenGrpMnuContainer => {
            if (iterOpenGrpMnuContainer.classList.contains("show")) {
                this.bootStrapCollapse(iterOpenGrpMnuContainer);
                iterOpenGrpMnuContainer.closest(".accordion-item")?.querySelector("button")?.classList?.add("collapsed");
            }
        });
    }

    getIcon(item) {
        return (item.closest(".accordion-item") || item.closest(".menuGroup")).querySelector(".collapse-expand-icon");
    }

    getHeader(icon) {
        return icon ? icon.closest(".menu-header") : undefined;
    }

    bootStrapCollapse(item) {
        new window["bootstrap"].Collapse(item)
        let icon = this.getIcon(item)
        if (icon && icon.classList.contains("bi-chevron-up")) {
            icon.classList.remove("bi-chevron-up");
            icon.classList.add("bi-chevron-down");
        }
        let header = this.getHeader(icon);
        header && header.classList.add("collapsed")
    }

    bootStrapExpand(item) {
        new window["bootstrap"].Collapse(item, { toggle: true })
        let icon = this.getIcon(item)
        if (icon && icon.classList.contains("bi-chevron-down")) {
            icon.classList.remove("bi-chevron-down");
            icon.classList.add("bi-chevron-up");
        }
        let header = this.getHeader(icon);
        header && header.classList.remove("collapsed")
    }

    onBackdropClick(e) {
        e && e.stopPropagation();
        this.publicApp().toggleHamburgerMenu();
    }

    onMenuItemIconClick(e, id){
        e && e.stopPropagation();
        const head = this.shadowRoot?.querySelector(`#${id}`)
        const ele:any = {target: head}
        if ( head?.classList.contains('collapsed')) {
            this.toggleGroupMenu(ele);
        }

        this.publicApp().collapseDesktopNavigationMenu('open');
    }

    onSearchIconClick = async() => {
        this.publicApp().collapseDesktopNavigationMenu('open');
        this.shadowRoot?.getElementById('nav-menu-search-input')?.focus()
    }

    onParentMenuIconClick=()=>{
        this.publicApp().collapseDesktopNavigationMenu('open');
    }

    onMenuItemClick=(cMenu: any)=>{
        const func = new Function(`${cMenu.method}('${cMenu.link}')`)
        func()
        if(window.innerWidth < SCREEN_LARGE){
            this.publicApp().toggleHamburgerMenu();
            this.searchText = ''
        }
    }

    onClickMenuGrougWithoutChild=(cMenu: any)=>{
        this.collapseAllGroupMenu()
        this.onMenuItemClick(cMenu)
    }

    renderSearchBar() {
        return html`
        <div class="nav-menu-search hide-on-collapse-navbar">
           <input id="nav-menu-search-input" class="hide-on-collapse-navbar" maxlength="40" .value=${this.searchText} placeholder='Menu Search' @input=${(e) => this.onSearch(e.target.value)}/>
           ${this.searchText ? html`<i class="bi bi-x search-icon" @click=${() => this.onSearch('')}></i>` : html`<i class="bi bi-search search-icon"></i>`}
        </div>
        <div class="nav-menu-search nav-menu-collapsed-search show-on-collapse-navbar d-none">
           <i class="bi bi-search" @click=${()=>this.onSearchIconClick()}></i>
        </div>
    `
    }

    renderNoResultCard = () => {
        return html`
        <div class="no-result-card">
            <span> No results for</span>
            "<span class="fw-bold">${this.searchText}</span>"
        </div>`
    }
    
    renderMenuItem(cMenu: any) {
        return html`
        <div id="submenu-${cMenu.menuId}">
            <div class="accordion-body">
                    <span @click=${()=> this.onMenuItemClick(cMenu)} id="menu-option">
                    ${cMenu.label}
                    </span>
            </div>
        </div>
    `
    }

    //returns menu item header UI with icon
    getGroupHeader(mnuGroup) {
        if (mnuGroup.children && mnuGroup.children.length) {
            return html`
                <div id="menu-group-wrap-${mnuGroup.menuId}" class="menu-header ${this.searchText ? 'menu-header-disabled' : 'collapsed'} d-flex justify-content-between align-items-center" @click=${this.groupHeaderClick}>
                    <div class="d-flex align-items-center">
                        <i data-bs-toggle="tooltip" data-bs-placement="top" title=${mnuGroup.label} class="bi bi-${mnuGroup.iconName} menu-header-icon pe-2 show-on-collapse-navbar d-none" @click=${(e)=>this.onMenuItemIconClick(e, `menu-group-wrap-${mnuGroup.menuId}`)}></i>
                        <i class="bi bi-${mnuGroup.iconName} menu-header-icon pe-2 hide-on-collapse-navbar"></i>
                        <span class="menu-header-label hide-on-collapse-navbar">${mnuGroup.label}</span>
                    </div>
                   ${this.searchText ? null : html`<i class="bi bi-chevron-down menu-arrow-icon collapse-expand-icon hide-on-collapse-navbar"></i>`}
                </div>
            `;
        } else {
            return html`
                <div class="menu-header collapsed d-flex align-items-center" @click=${()=>this.onClickMenuGrougWithoutChild(mnuGroup)}>
                    <i data-bs-toggle="tooltip" data-bs-placement="top" title=${mnuGroup.label} class="bi bi-${mnuGroup.iconName} menu-header-icon pe-2 show-on-collapse-navbar d-none" @click=${() => this.onParentMenuIconClick() }></i>
                    <i class="bi bi-${mnuGroup.iconName} menu-header-icon pe-2 hide-on-collapse-navbar"></i>
                    <span class="menu-header-label hide-on-collapse-navbar">${mnuGroup.label}</span>
                </div>
            `;
        }
    }

    //returns menu item header and render accordion view if there is a hierarchy 
    renderMenuGroup(mnuGroup: any, index: number) {
        return html`
            <div class="menuGroup">
                ${this.getGroupHeader(mnuGroup)}
                <div class="accordion-container ${this.searchText ? 'search-accordion-container': 'collapse accordion-collapse'} ${mnuGroup.children && mnuGroup.children.length ? 'hide-on-collapse-navbar' : 'd-none'}">
                    <div class="accordion" id="menu-group-${index}">
                        ${mnuGroup.children && mnuGroup.children.map((gMenu: any) => this.renderMenuItem(gMenu))}
                    </div>
                </div>
            </div>
        `;
    }
 
    renderMenu = () => {
        if (this.searchText && this.navigationSearchResult.length === 0) {
            return this.renderNoResultCard()
        } else {
            return (this.searchText ? this.navigationSearchResult : this.navigationMenuItems.mainMenu).map((mnuGrp: any, index: number) => this.renderMenuGroup(mnuGrp, index))
        }
    }

    render() {
        if (!this.navigationMenuItems) {
            return html``;
        }
        return html`
        <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
    
        <div class="nav-menu-container" id=nav-menu-container">
            ${this.renderSearchBar()}
            ${this.renderMenu()}
        </div>
        <div id="nav-menu-backdrop" class="modal semitransparent d-none nav-menu-backdrop d-lg-none" @click=${this.onBackdropClick}></div>
    `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-navigation-menu': PublicAppNavigationMenu;
    }
}